export class TemplateResponse {
  hotelId: string
  id: string
  name: string
  description: string
  data: string
  dataDraft: string
  htmlVersionDataDraft: string
  rootIds: string[]
  templateType: string
  lastModified: Date
  created: Date
  lastPublished: Date
  createdBy: string
  status: string
  objective: string
  previewImageUrl: string
  unPublishedChanges: boolean
  dynamicVariableList: string
  dynamicVariableListDraft: string
  isActiveEditing: string
  isActiveEditingObject?: IsActiveEditingObject
}

export class IsActiveEditingObject {
  email: string
  hash: string
}

export class UpdateTemplateDraftRequest {
  hotelId: string
  id: string
  dataDraft: string
  lastModified: Date
  objective: string
  name: string
  description: string
  templateType: string
  created: Date
  createdBy: string
  status: string
  unPublishedChanges: boolean
  dynamicVariableList: string
  previewImageUrl: string
  dynamicVariableListDraft: string
  isActiveEditing: string
}

export class LanguageResponse {
  code: string
  name: string
  nativeName: string
  message: string
  htmlVersionMessage: string
}

export class EmailMessage {
  Data: TemplateElement[]
  MetaData: EmailMetaData
}

export class EmailMetaData {
  FromName: string
  FromEmail: string
  Subject: string
  SubjectLanguage?: any
  PreviewText: string
  PreviewTextLanguage?: any
}

export class TemplateElement {
  [x: string]: any
  elementType: string
  img: string
  id: string
  text: string
  inlineStyle: Styles
  urlLink: string
  multipleColumns: boolean
  columnContent: ColumnElement[]
  background: string
}

export class ColumnElement {
  elementType: string
  img: string
  imgAspectRatio: string
  imgCropping: string
  id: string
  text: string
  languageText: any
  inlineStyle: Styles
  fullWidthBackground: boolean
  urlLink: string
  urlLinkType: string
  constructor(
    elementType: string = "",
    id: string = "",
    img: string = "",
    imgAspectRatio: string = "",
    imgCropping: string = "",
    inlineStyle: Styles,
    urlLink: string = "",
    urlLinkType: string = "",
    text: string = "",
    languageText: Map<string, string> = new Map<string, string>(),
    fullWidthBackground: boolean = false,
  ) {
    this.elementType = elementType
    this.id = id
    this.img = img
    this.imgAspectRatio = imgAspectRatio
    this.imgCropping = imgCropping
    this.inlineStyle = inlineStyle
    this.urlLink = urlLink
    this.urlLinkType = urlLinkType
    this.fullWidthBackground = fullWidthBackground
    this.text = text
    this.languageText = languageText
  }
}

export interface Styles {
  paddingTop?: string
  paddingBottom?: string
  paddingLeft?: string
  paddingRight?: string
  marginBottom?: string
  marginTop?: string
  marginLeft?: string
  marginRight?: string
  backgroundColor?: string //Background of section
  width?: string
  height?: string
  buttonSize?: string
  textAlignment?: string
  borderRadius?: string
  color?: string
  border?: string //Border around button
  borderTop?: string //Border used as line in Divider
  background?: string //Background of element like button
  fontSize?: string
  fontFamily?: string
  fontWeight?: string
  fontStyle?: string
  textDecoration?: string
  layoutMax?: string
  buttonTransparent?: boolean
  opacity?: string //Opacity for line
  ImageBorderRadiusTopLeft?: string
  ImageBorderRadiusTopRight?: string
  ImageBorderRadiusBottomLeft?: string
  ImageBorderRadiusBottomRight?: string
  ImageVerticalAlignment?: string
  individualPadding?: boolean
}

export interface InputValue {
  direction: string
  value: number
  label?: string
}
